import React, { useEffect, useState } from 'react';
import SharedStateBridge, { SharedStateType } from '@sendible/shared-state-bridge';
import VideoEditor from './videoEditor';
import { EDITOR_VIDEO_OPEN } from '.';

const VideoInitialiser = () => {
  const [data, setData] = useState<OpenVideoEditorDataType>({} as OpenVideoEditorDataType);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      const { eventName, data: eventData } = event.data;

      if (eventName === EDITOR_VIDEO_OPEN && eventData) {
        SharedStateBridge.setItem({ user: eventData.user, compose: {}, app: {} } as SharedStateType);

        window.pendo.initialize({
          visitor: eventData.pendoUserData,
          account: eventData.pendoAccountData,
        });

        setData({
          domainUrl: eventData.domainUrl,
          user: eventData.user,
          originalUrl: eventData.originalUrl,
          originalMediaId: eventData.originalMediaId,
          fileName: eventData.fileName,
          resetState: () => {
            setData({} as OpenVideoEditorDataType);
          },
          restrictedServices: eventData.restrictedServices,
          serviceSet: eventData.serviceSet,
          metadata: eventData.metadata,
        });
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  if (!data.originalUrl) {
    return null;
  }

  if (data.originalUrl) {
    return (
      <React.StrictMode>
        <VideoEditor {...data} />
      </React.StrictMode>
    );
  }

  return null;
};

export default VideoInitialiser;
